'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useLookupsStore } from '@repo/store/useLookupsStore'
import { useNewMatterStore } from '@repo/store/useNewMatterStore'

export const DepartmentSelect = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx,
  size = 'small',
  required,
  errors = {}
}) => {
  const { fetchDepartments, departments } = useLookupsStore()
  const { department } = useNewMatterStore()
  const [options, setOptions] = useState(testData || departments || [])
  const [selectedValue, setSelectedValue] = useState(value)

  useEffect(() => {
    if (testData) return
    setOptions(departments || [])
  }, [testData, departments])

  useEffect(() => {
    if (testData || departments?.length) return
    fetchDepartments()
  }, [testData, departments, fetchDepartments])

  // Effect to map number `value` to corresponding object
  useEffect(() => {
    if (department) {
      setSelectedValue(department)
    } else if (typeof value === 'number') {
      const selectedDepartment = options.find((department) => department.departmentId === value)
      if (selectedDepartment) {
        setSelectedValue(selectedDepartment)
      }
    } else {
      setSelectedValue(value)
    }
  }, [value, options, department])

  return (
    <div data-testid="DepartmentSelect" style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%' }}>
      <ReactSelectMenu
        label="Department"
        onChange={(newVal) => {
          onChange(newVal)
          setSelectedValue(newVal)
        }}
        labelKey="description"
        valueKey="departmentId"
        items={options}
        value={selectedValue}
        searchable
        idLabelKey="departmentId"
        showIdInResults={false}
        name="department"
        size={size}
        required={required}
        errors={errors}
      />
    </div>
  )
}

DepartmentSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string,
  required: PropTypes.bool,
  errors: PropTypes.object
}
